import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'jbm-plant-selector',
  templateUrl: './JBMPlantSelector.component.html',
  styleUrls: ['./JBMPlantSelector.component.scss']
})
export class JBMPlantSelectorComponent {

  @Input() id: string='jbm-plant-selector'
  @Input() plants: any[]=[]
  @Input() selection: number = -1
  @Input() showLabel: boolean = true
  @Input() class: string = ''

  @Output() onSelectionChange=new EventEmitter()

  async onChange(event: any) {
    this.selection=parseInt(event.target.value)
    this.onSelectionChange.emit(this.selection)
  }
}
